// M004-F0764 (WebUI #237): tab model for /app/admin/rooms.
//   [Rooms] [<one tab per non-deleted room>] [Term Planner] [Term Settings] [Access]
// Room tab sub-tabs: [Overview] [Climate Controls] [Sensors] [All Linked Devices].
// Climate and Sensors are admin-only; the read-only device list follows the room_devices_read boundary.

export const ROOM_SUB_TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'climate', label: 'Climate Controls' },
  { id: 'sensors', label: 'Sensors' },
  { id: 'devices', label: 'All Linked Devices' },
];
export const DEFAULT_SUB_TAB = 'overview';

export const MANAGEMENT_TABS = [
  { id: 'rooms', label: 'Rooms' },
];
export const TRAILING_MANAGEMENT_TABS = [
  { id: 'term-bookings', label: 'Term Planner' },
  { id: 'term-settings', label: 'Term Settings' },
  { id: 'access', label: 'Access' },
];

// Room-list order; a soft-deleted room never has a tab.
export const roomsWithTabs = (rooms) => (Array.isArray(rooms) ? rooms : []).filter((r) => r && !r.is_deleted);

export const roomTabKey = (room) => `room:${room.id}`;

export const buildTopTabs = ({ rooms, isAdmin }) => [
  ...(isAdmin ? MANAGEMENT_TABS : []),
  ...roomsWithTabs(rooms).map((room) => ({ id: roomTabKey(room), label: room.name, roomId: String(room.id) })),
  ...(isAdmin ? TRAILING_MANAGEMENT_TABS : []),
];

export const visibleSubTabs = ({ isAdmin, canViewDevices = isAdmin }) => ROOM_SUB_TABS.filter((tab) => {
  // no capability exists for the climate or sensor READ yet
  if (tab.id === 'climate' || tab.id === 'sensors') return Boolean(isAdmin);
  if (tab.id === 'devices') return Boolean(canViewDevices);
  return true;
});

// ?room=<id>&roomTab=overview|climate|sensors. Any other roomTab value falls back to overview.
// Returns null for an unknown or invisible room (caller falls back without saying whether the room exists).
export const resolveRoomDeepLink = ({ roomParam, subTabParam, rooms, isAdmin, canViewDevices = isAdmin }) => {
  if (!roomParam) return null;
  const room = roomsWithTabs(rooms).find((r) => String(r.id) === String(roomParam));
  if (!room) return null;
  const allowed = visibleSubTabs({ isAdmin, canViewDevices }).map((t) => t.id);
  const subTab = allowed.includes(subTabParam) ? subTabParam : DEFAULT_SUB_TAB;
  return { room, subTab };
};
